import React from 'react';
import shallowEqual from 'react-pure-render/shallowEqual';

export default class Loader extends React.Component {

	static propTypes = {
		visible: React.PropTypes.bool,
		delay: React.PropTypes.number,
		image: React.PropTypes.string,
		className: React.PropTypes.string,
	};

	static defaultProps = {
		visible: false,
		ready: true,
		delay: 400,
		top: '50%',
		left: '50%',
		width: 64,
		opacity: 0.25,
		background: '#E5E5E5',
		className: 'loader-mask',
		image: __MOBILE__ ? 'img/ajax-loader.gif' : '/img/ajax-loader.gif'
	};

	constructor(props) {
		super(props);
		this.state = {visible: false};
		if (props.visible) {
			this.timeout = setTimeout(() => {
				this.setState({visible: true});
			}, props.delay);
		}
	}

	shouldComponentUpdate(nextProps, nextState) {

		const shouldUpdate =
			!shallowEqual(this.props, nextProps) ||
			!shallowEqual(this.state, nextState);


		return shouldUpdate;
	}
	componentWillReceiveProps(nextProps) {
		if (nextProps.visible && !this.props.visible) {
			this.timeout = setTimeout(() => {
				if (false && __MOBILE__) {
					window.plugins.spinnerDialog.show('Načítám data ...', null, true);
				}
				this.setState({visible: true});
			}, this.props.delay);
		}
		else {
			if (nextProps.visible == false) {
				if (this.timeout) {
					clearTimeout(this.timeout);
				}
				if (__MOBILE__) {
					window.plugins.spinnerDialog.hide();
				}
				this.state.visible = nextProps.visible;
			}
		}
	}

	render() {
		if (!this.state.visible) {
			return this.props.children ? this.props.children : false;
		}
		const content = this.props.ready ? this.props.children : false;

		return (
			<span className={this.props.className}>
				<div className={this.props.className} style={{position:'absolute', background:this.props.background, zIndex: 1000, opacity:this.props.opacity}}>
				</div>
				<div style={{position:'absolute', zIndex: 1001, top: this.props.top, left: this.props.left, width: this.props.width, bottom: 0}}>
					<img src={this.props.image} />
				</div>
				{content}
			</span>
		)
	}
}


// WEBPACK FOOTER //
// ./src/reactis/reactis-loader/src/Loader.js